import styled from 'styled-components';

import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
  Image as SemanticImage,
} from 'semantic-ui-react';

import {
  Loader as LoaderLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';
import MenuLayoutComponent from '../../../core/layout-components/menu';

const Container = styled.div`
  display: block;
  width: 100%;
  min-width: 150px;
`;

const ContainerMessage = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
  font-size: 18px;
`;

const Title = styled.p`
  font-size: 24px;
  font-weight: ${(props) => (props.weight ? props.weight : '500')};
  margin-bottom: 25px;
`;

const UserComponent = styled(Container)`
  &&& {
    display: flex;
    padding: 13px;
  }
`;

const Grid = styled(SemanticGrid)`
  &&& {
    flex: 1;
    text-align: center;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&& {
    align-self: center;
    font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
  }

  ${({ noPadding }) => noPadding && `
    &&&.column {
      padding: 0;
    }`
  }
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    align-self: center;
  }
`;

const CardClickRow = styled(SemanticGrid.Row)`
  &&& {
    :hover {
      cursor: pointer;
    }
    align-self: center;
  }
`;

const CardRow = styled(SemanticGrid.Row)`
  &&& {
    padding: 7.5px 0;
  }
`;

const Icon = styled(SemanticIcon)`
  cursor: pointer;
  margin-right: 15px;
  font-size: 1em !important;
`;

const Card = styled(SegmentLayoutComponent)`
  &&& {
    flex-direction: column;
    min-height: 72px;
    min-width: 150px;
    padding: 0 10px;
    text-align: center;
    width: 100%;
  }
`;

const MenuContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0 10px 10px 10px;
`;

const Menu = styled(MenuLayoutComponent)``;

const Item = styled(MenuLayoutComponent.Item)``;

const CardHeader = styled.div`
  justify-content: center;
  height: 70px;
  display: flex;
`;

const LinkedInInfo = styled.span`
  color: red;
  font-weight: 500;
  font-size: 12px;
`;

const ColumnText = styled(TextLayoutComponent.Span)`
  &&& {
    font-size: '16px';
    color: ${(props) => (props.color ? props.color : 'inherit')};
    font-weight: ${(props) => (props.weight ? props.weight : 'normal')};
  }
`;

const Image = styled(SemanticImage)`
  &&& {
    margin-left: 15px;
    height: 40px;
    width: 40px;
  }
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({ inline: 'centered' }))`
  &.ui.loader {
    margin-top: 20px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SearchContainer = styled.div``;

const Link = styled.a``;

export {
  Card,
  CardClickRow,
  CardHeader,
  CardRow,
  Column,
  ColumnText,
  Container,
  ContainerMessage,
  Grid,
  Icon,
  Image,
  Item,
  LinkedInInfo,
  Loader,
  Menu,
  MenuContainer,
  Row,
  Title,
  UserComponent,
  Header,
  SearchContainer,
  Link,
};
